<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button icon="sync" @click="apiSaleStatistics">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="售票统计查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">服务商：</div>
						<a-select v-model="query.facilitatorId" @change="facilitatorChange">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option v-for="(item, index) in facilitatorList" :key="index" :value="item.facilitatorId">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3" v-if="query.reportType == 1">
						<div class="qinang-search-col-title">查询日期：</div>
						<a-date-picker mode="date" v-model="query.startDay" valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" class="qinang-search-time-picker-2" />
						<span style="width: 20px;text-align: center;">-</span>
						<a-date-picker mode="date" v-model="query.endDay" valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" class="qinang-search-time-picker-2" />
					</div>
					<div class="qinang-search-col-3" v-if="query.reportType == 2">
						<div class="qinang-search-col-title">查询日期：</div>
						<a-month-picker v-model="query.startMonth" valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM" class="qinang-search-time-picker-2" :showToday="false" />
						<span style="width: 20px;text-align: center;">-</span>
						<a-month-picker v-model="query.endMonth" valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM" class="qinang-search-time-picker-2" :showToday="false" />
					</div>
					<div class="qinang-search-col-3" v-if="query.reportType == 3">
						<div class="qinang-search-col-title">查询日期：</div>
						<a-select v-model="query.startYear" class="qinang-search-select-2" >
							<a-select-option v-for="(item, index) in yearList" :key="index" :value="item">{{item}}</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">报表类型：</div>
						<a-radio-group v-model="query.reportType" style="margin-left: 14px;">
							<a-radio :value="1">日报表</a-radio>
							<a-radio :value="2">月报表</a-radio>
							<a-radio :value="3">年报表</a-radio>
						</a-radio-group>
					</div>
				</div>
				<div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
					<a-button type="primary" icon="search" @click="apiSaleStatistics">查询</a-button>
					<a-button icon="redo" @click="resetQuery" style="margin-left: 14px;">重置</a-button>
					<a-button type="primary" icon="download" @click="dowTable" style="margin-left: 14px;">导出</a-button>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card" loading="tableLoading">
			<div style="width: 100%;text-align: center;margin: 20px;font-size: 16px;">售票统计表</div>
			<div style="margin: 0 40px 20px;text-align: right;">
				<span> {{ queryDate }} </span>
				<span style="margin-left: 20px;">报表类型：{{ queryType}}</span>
				<span style="margin-left: 20px;">服务商：{{selectedFacilitatorName}}</span>
			</div>
			<div style="margin: 20px 40px;overflow-x: auto;">
				<table id="reportTable" class="qa-ticket-sales-table" style="width: 100%;border-collapse: collapse;">
					<thead>
						<tr>
							<th rowspan="2" class="qa-th-merged">交易日期</th>
							<th rowspan="2" class="qa-th-merged">产品名称</th>
							<th rowspan="2" class="qa-th-merged">人群</th>
							<th rowspan="2" class="qa-th-merged">单价</th>
							<th rowspan="2" class="qa-th-merged">售票员</th>
							<th colspan="3"  class="qa-th-merged">数量</th>
							<th rowspan="2" class="qa-th-merged">应收金额</th>
						</tr>
						<tr>
							
							<th class="qa-th-merged">出票</th>
							<th class="qa-th-merged">退票</th>
							<th class="qa-th-merged">实际出票</th>
						</tr>
					</thead>
					<tbody >
						<!-- 模拟数据 -->
						<tr v-for="(tr, index) in tableData" :key="index" >
                            <template v-for="(td) in tr.tr" >
                                <td v-if="td.colspan>0" :rowspan="td.rowspan" :colspan="td.colspan" :class="td.class">{{ td.value }} </td>
                            </template>
						</tr>
					</tbody>

				</table>
			</div>
			<div style="margin: 20px 40px;text-align: right;">
				<span>制表人：{{staffName}}</span>
				<span style="margin-left: 20px;">打印时间：{{moment().format('YYYY-MM-DD HH:mm:ss')}}</span>
			</div>
		</div>
	</div>
</template>

<script>
	import FileSaver from 'file-saver'
	import * as XLSX from 'xlsx'
	import moment from 'moment'
	import { parseTableData } from './TicketSalesReport'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				facilitatorList: [],//服务商列表
				ticketstationList: [],//售票站点列表
				staffList: [],//售票员列表
				staffName: window.sessionStorage.getItem('staffName') || '测试',
				selectedFacilitatorName: '全部',
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: 0,
					startDay: moment().format('YYYY-MM-DD')+' 00:00:00',
					endDay: moment().format('YYYY-MM-DD')+' 23:59:59',
					startMonth: moment().format('YYYY-MM') + '-01 00:00:00',
					endMonth: moment().format('YYYY-MM') + '-01 23:59:59',
					startYear: moment().format('YYYY'),
					reportType: 1,
				},
				tableData: [],

                apiReturnData: [],
                yearList: [
					2023,2024,2025,2026,2027,2028,2029,2030
				],//年份列表
                staffList: [],//售票员列表
				tableLoading: false,
				queryDate: '',//查询日期
				queryType: '',//报表类型
				//搜索+表格-end

			};
		},
		methods: {
            parseTable(){
				let tableData = parseTableData(this.apiReturnData)
				// console.log(tableData)
                this.tableData = tableData
            },

			async apiFacilitatorListForStaff() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorListForStaff, {staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data
					console.log(this.facilitatorList)
				} else {
				
				}
			},
			facilitatorChange(e) {
				if(e == 0) {
					this.ticketstationList = []
					this.selectedFacilitatorName = '全部'
				} else {
					this.apiTicketstationList()
					const facilitator = this.facilitatorList.find(item => item.facilitatorId == e)
					this.selectedFacilitatorName = facilitator ? facilitator.facilitatorName : '全部'
				}
				this.query.ticketstationId = 0
			},
			async apiTicketstationList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiTicketstationList, {facilitatorId:this.query.facilitatorId});
				if (res.code == 200) {
					this.ticketstationList = res.data
				} else {
				
				}
			},
			async apiStaffList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiStaffList, {staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.staffList = res.data
				} else {
				
				}
			},
			async apiSaleStatistics() {
				let queryData = this.query
				switch (this.query.reportType) {
					case 1:
						queryData.startDay = this.moment(this.query.startDay).format('YYYY-MM-DD')+' 00:00:00'
						queryData.endDay = this.moment(this.query.endDay).format('YYYY-MM-DD')+' 23:59:59'
						break;
					case 2:
						queryData.startMonth = this.moment(this.query.startMonth).format('YYYY-MM')+'-01 00:00:00'
						queryData.endMonth = this.moment(this.query.endMonth).format('YYYY-MM')+'-01 23:59:59'
						break;
					case 3:
						queryData.startYear = this.query.startYear
						break;
				}
				queryData.staffId = window.sessionStorage.getItem('staffId')
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiSaleStatistics, queryData);
				if (res.code == 200) {
					this.apiReturnData.staffList = res.data.staffList
					this.apiReturnData.priceList = res.data.priceList
					this.apiReturnData.saleList = res.data.saleList
					this.apiReturnData.refundList = res.data.refundList
					this.parseTable()
					switch (this.query.reportType) {
					case 1:
						this.queryDate = this.moment(this.query.startDay).format('YYYY-MM-DD') + ' 至 ' + this.moment(this.query.endDay).format('YYYY-MM-DD')
						break;
					case 2:
						this.queryDate = this.moment(this.query.startMonth).format('YYYY-MM') + ' 至 ' + this.moment(this.query.endMonth).format('YYYY-MM')
						break;
					case 3:
						this.queryDate = this.query.startYear + '年'
						break;
				}
				this.queryType = this.query.reportType == 1 ? '日报表' : this.query.reportType == 2 ? '月报表' : '年报表'
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
				
			},
			resetQuery() {
				this.query = {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: 0,
					ticketstationId: 0,
					staffId: 0,
					startDay: moment().format('YYYY-MM-DD')+' 00:00:00',
					endDay: moment().format('YYYY-MM-DD')+' 23:59:59',
					startMonth: moment().format('YYYY-MM') + '-01 00:00:00',
					endMonth: moment().format('YYYY-MM') + '-01 23:59:59',
					startYear: moment().format('YYYY'),
					reportType: 1,
				}
				this.ticketstationList = []
				this.selectedFacilitatorName = '全部'
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiSaleStatistics()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiSaleStatistics()
			},
			dowTable() {
				// 检查 XLSX 是否加载成功
				if (!XLSX || !XLSX.utils || !XLSX.write) {
					console.error('XLSX library not loaded');
					return;
				}
				try {
					let et = XLSX.utils.table_to_book(document.getElementById("reportTable")); //此处传入table的DOM节点
					let etout = XLSX.write(et, {
						bookType: "xlsx",
						bookSST: true,
						type: "array"
					});
					try {
						FileSaver.saveAs(
							new Blob([etout], {
								type: "application/octet-stream"
							}),
							`${this.queryType}${this.queryDate}销售统计报表.xlsx`
						); //导出的文件名
					} catch (e) {
						console.log(e, etout);
					}
					return etout;
				} catch (e) {
					console.error('Error exporting table:', e);
					return;
				}
			},
		},
		computed: {
			
		},
		created() {
            // this.parseTable()
			this.apiFacilitatorListForStaff()
			// this.apiStaffList()
			this.apiSaleStatistics()
		}
	};
</script>

<style scoped>
	.qa-ticket-sales-table {
		border: 1px solid #000;
	}
	
	.qa-th-merged {
		text-align: center;
		border: 1px solid #000;
		background-color: #d3e0f0;
		padding: 5px;
	}
	
	.qa-td-merged {
		text-align: center;
		border: 1px solid #000;
		padding: 5px;
		vertical-align: middle;
	}
	
	.qa-td-normal {
		text-align: center;
		border: 1px solid #000;
		padding: 5px;
	}
	
	.qa-td-subtotal {
		text-align: center;
		border: 1px solid #000;
		padding: 5px;
		background-color: #e7edf4;
		font-weight: bold;
	}
	
	.qa-td-total {
		text-align: center;
		border: 1px solid #000;
		padding: 5px;
		background-color: #e0e7f3;
		font-weight: bold;
	}
</style>
